import { HsiycSearchVehiclesRecord } from '@/types/legacy-api/graphql';

// Gets the count of unique variants from the page vehicle object. This is required because duplicate vehicles can exist in pageVehicles.
const getVariantCount = ({ vehicles }: { vehicles: HsiycSearchVehiclesRecord[] }): number => {
  const uniqueVariants = new Set<string>();

  vehicles.forEach((vehicle) => {
    if (vehicle && vehicle.redbookCode) {
      uniqueVariants.add(vehicle.redbookCode);
    }
  });

  return uniqueVariants.size;
};

export default getVariantCount;
